
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...page-slugs]]",
      function () {
        return require("private-next-pages/[[...page-slugs]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...page-slugs]]"])
      });
    }
  